import { ABSOLUTE_HTTP_HREF_PATTERN, REACT_ID_SEPARATOR_PATTERN } from "../onboardingAgentConstants";

type ExternalLinkAttributes = {
    readonly rel: "noopener noreferrer";
    readonly target: "_blank";
};

export const SAFE_HREF_FALLBACK = "#";
const UNSAFE_PROTOCOL_HREF_PATTERN = /^(?!https?:)[a-z][a-z\d+\-.]*:/i;
const DELETE_CONTROL_CHARACTER_CODE = 0x7f;
const SPACE_CHARACTER_CODE = 0x20;

const removeControlAndWhitespaceCharacters = (value: string): string =>
    Array.from(value)
        .filter((character) => {
            const characterCode = character.charCodeAt(0);

            return characterCode > SPACE_CHARACTER_CODE && characterCode !== DELETE_CONTROL_CHARACTER_CODE;
        })
        .join("");

const RANDOM_SUFFIX_RADIX = 36;
const RANDOM_SUFFIX_START_INDEX = 2;

const createFallbackMessageId = (): string =>
    `${Date.now()}-${Math.random().toString(RANDOM_SUFFIX_RADIX).slice(RANDOM_SUFFIX_START_INDEX)}`;

export const createMessageId = (): string =>
    typeof crypto !== "undefined" && "randomUUID" in crypto ? crypto.randomUUID() : createFallbackMessageId();

export const getCurrentPageUrl = (): string =>
    window.location.hash || `${window.location.pathname}${window.location.search}`;

export const isAbsoluteHref = (href: string): boolean => ABSOLUTE_HTTP_HREF_PATTERN.test(href);

export const getSafeHref = (href: string): string => {
    const trimmedHref = href.trim();
    const hrefForProtocolCheck = removeControlAndWhitespaceCharacters(trimmedHref);

    if (hrefForProtocolCheck.startsWith("//")) {
        return SAFE_HREF_FALLBACK;
    }

    return UNSAFE_PROTOCOL_HREF_PATTERN.test(hrefForProtocolCheck) ? SAFE_HREF_FALLBACK : trimmedHref;
};

export const getExternalLinkAttributes = (href: string): ExternalLinkAttributes | Record<string, never> =>
    isAbsoluteHref(href) ? { rel: "noopener noreferrer", target: "_blank" } : {};

export const createDomSafeId = (prefix: string, reactId: string): string =>
    `${prefix}-${reactId.replace(REACT_ID_SEPARATOR_PATTERN, "")}`;
